import styled from "styled-components";
import { baseColors } from "../../../../themes/definitions/si/cis/base-colors";
import {VouchersGamesListTitleDefaultBox} from "./voucher-games-list-title.default.box";

export const VouchersGamesListTitleSICisBox = styled(VouchersGamesListTitleDefaultBox)`
    font-size: 1.15rem;
    ${({theme}) => theme.font.presets.thin}
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
    background-color: ${baseColors.gray023};
`;
